<template>
  <div class="home">
    <BlogPost :post="welcomeScreen" />
    <BlogPost
      :post="post"
      v-for="(post, index) in sampleBlogPost"
      :key="index"
    />
    <div class="blog__card__wrap">
      <div class="container">
        <h3 class="tit">شاهد المزيد من المنشورات</h3>
        <div class="blog__cards">
          <BlogCard
            :post="post"
            v-for="(post, index) in sampleBlogCards"
            :key="index"
          />
        </div>
      </div>
    </div>
    <!-- login in section -->
    <div class="rgstr" v-if="!user">
      <div class="rgstr__container">
        <h2>أشترك حتي لا يفوتك أجدد المقالات</h2>
        <div class="btn__container">
          <router-link to="#" class="rgstr__btn">
            <Arrow class="arrow" />
            قم بالتسجيل الأن
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlogPost from "../../components/BlogPost";
import BlogCard from "../../components/BlogCard";
import Arrow from "../../src/assets/Icons/arrow-left-light.svg";
export default {
  name: "Home",
  components: { BlogPost, BlogCard, Arrow },
  data() {
    return {
      welcomeScreen: {
        title: "مرحبا",
        blogPostt:
          "أهلا بك في مدونة الرؤي المختصة في الكلام عن كل ما يخص علم التجويد و القراءات",
        photo: "ar1",
        welcomeScreenn: true,
      },
      sampleBlogPost: [
        {
          title: "كيف تحفظ القران في سنتين",
          blogHTML:
            "حفظ القران من أهم الأشياء التي يتقرب بها العبد و في نفس الوقت اكثر ما يقصر فيه المسلمونززز",
          blogCoverPhoto: "ar2",
        },
        {
          title: "علم التجويد للمبتدئين",
          blogHTML: "من الأخفاء و الأظهار الي القلقله و المدز",
          blogCoverPhoto: "ar3",
        },
      ],

    };
  },
  computed:{
    sampleBlogCards(){
      return this.$store.state.sampleBlogCards
    },
    user(){
      return this.$store.state.user
    }
  }
};
</script>
<style lang="scss">
.tit {
  font-size: 23px;
  margin: 0 10px 30px 0;
  font-weight: 400;
}
.rgstr {
  height:auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px 50px;
  @media (max-width: 800px) {
    padding: 100px 25px;
  }
  .rgstr__container {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 100px 50px;
    @media (max-width:800px) {
      flex-direction: column;
    }
    h2 {
      font-size: 55px;
      width: 30%;
      font-weight: 400;
      @media (max-width: 800px) {
        text-align: initial;
        font-size: 40px;
        width:100%;
        text-align: center;
        margin-bottom: 50px;
      }
    }
    .btn__container {
      display: flex;
      justify-content: center;
      align-items: center;
      .rgstr__btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        background: black;
        border: none;
        color: white;
        padding: 8px 17px;
        border-radius: 30px;
        font-size: 18px;
        text-decoration: none;
        @media (max-width: 800px) {
          padding: 7px 14px;
          border-radius: 30px;
          font-size: 16px;
        }
      }
      .arrow {
        position: relative;
        top: 3px;
        left: 10px;
        path {
          fill: white;
        }
      }
    }
  }
}
</style>
